import PropTypes from 'prop-types'
import React, { Component } from 'react'
import parse from 'url-parse'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { Loader } from 'components/util'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import * as auth from 'services/auth/selectors'
import * as authActions from 'services/auth/actions'
import * as premiumActions from 'services/premium/actions'
import * as premium from 'services/premium/selectors'
import * as site from 'services/site/selectors'
import * as userSelectors from 'services/user/selectors'
import * as deactivateActions from 'services/deactivate/actions'
import styles from 'components/deletion/_deletion.css'
import DeletionForm from './DeletionForm'
import SecondaryVerification from './SecondaryVerification'
import MvpConfirmation from './MvpConfirmation'
import UAIcon from 'images/UA_icon_sm_2x.png'

const mapStateToProps = (state) => ({
  error: auth.selectError(state),
  loggingIn: auth.selectLoggingIn(state),
  dev: site.selectDev(state),
  user: state.user,
  subscriptionPlatform: premium.selectSubPlatform(state),
  profileImg: userSelectors.selectProfileImgMed(state),
})

const mapDispatchToActions = {
  ...authActions,
  ...premiumActions,
  ...deactivateActions,
}

export class Deletion extends Component {

  static propTypes = {
    loggingIn: PropTypes.bool,
    loggedIn: PropTypes.string,
    login: PropTypes.func.isRequired,
    user: PropTypes.object,
    dev: PropTypes.bool,
    subscriptionPlatform: PropTypes.string,
    fetchPaidSubscriptions: PropTypes.func,
    deactivateUser: PropTypes.func,
    profileImg: PropTypes.string,
    redirectUri: PropTypes.string,
  };

  state = {
    submitting: false,
    error: null,
    loggedIn: false,
    password: null,
  }

  componentWillMount () {
    this.props.fetchPaidSubscriptions()
      .then(this.redirectIfNotPremium)
      .then(() => this.setState({ paidSubscriptionsLoading: false }))
      .catch(() => this.setState({
        paidSubscriptionsError: true,
        paidSubscriptionsLoading: false,
      }))
  }

  handleDeactivation = () => {
    const user = {
      password: this.state.password,
      id: this.props.user.id,
    }

    return this.props.deactivateUser(user)
    .then(this.onDeactivateSuccess)
    .catch((err) => {
      if (err
        && err.response
        && err.response.data
        && err.response.data.error
        && err.response.data.error === 'access_denied'
      ) {
        this.setState({ error: 'access_denied' })
      } else {
        this.setState({ error: 'unknown' })
      }
    })
  }

  onDeactivateSuccess = () => {
    const redirectUri = this.props.redirectUri || '/'
    window.location = redirectUri
  }

  handleLogin = ({ password }) => {
    const { dev } = this.props

    this.setState({ submitting: true, error: null, userError: null, password: password })

    return this.props.login({ username: this.props.user.email, password })
      .then(this.onLoginSuccess)
      .catch((err) => {
        this.setState({ submitting: false })

        if (err.user) {
          // there was a problem reloading user
          // the user is probably still logged in
          if (dev) {
            err.url = parse(err.config.url, true)
            this.setState({ userError: err })
          } else {
            this.setState({ error: 'unknown' })
          }
        } else if (err
          && err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error === 'access_denied'
        ) {
          this.setState({ error: 'access_denied' })
        } else {
          this.setState({ error: 'unknown' })
        }
      })
  }

  onLoginSuccess = () => {
    this.setState({ submitting: false, loggedIn: true })
  }

  getErrorMessage = (code) => {
    const messages = {
      'unknown': (<FormattedMessage
        id='auth.password.verification.unknown'
        defaultMessage='An unknown error has occured. Please try again.'
      />),
      'access_denied': (<FormattedMessage
        id='auth.password.verification.failed'
        defaultMessage='Password is incorrect.'
      />),
    }

    if (code in messages) {
      return messages[code]
    }
  }

  clearErrors = () => {
    this.setState({
      error: null,
    })
  }

  render () {
    const { dev, subscriptionPlatform, user, profileImg } = this.props
    const { submitting, error, userError, loggedIn } = this.state
    const joinedDate = user.date_joined

    return (
      <div className={styles.container}>
        <ReactCSSTransitionGroup
          component='div'
          transitionName='fade'
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
          >
          {submitting ?
            <div key='loader'>
              <div className={styles.loader}>
                <Loader height={50} width={50} />
              </div>
            </div>
            : null}
        </ReactCSSTransitionGroup>

        <header className={styles.deleteHeader}>
          <img className={styles.profilePic} src={profileImg} />
          <div className={styles.infoContainer}>
            <h4 className={styles.displayName}>{user.display_name}</h4>
            <p className={styles.memberText}>
              <FormattedMessage id='auth.password.membship.year' defaultMessage='Member Since ' />
              {moment(joinedDate).year()}
              <br />
              {user.location && user.location.locality ?
                <span>{user.location.locality}, {user.location.region}</span>
              : ''}
            </p>
          </div>
        </header>

        <p className={styles.UAIcon}>
          <img src={UAIcon} className={styles.UAIconImg} />
        </p>

        {!loggedIn ?
          <div className={styles.formContainer}>

            {error ?
              <div className={styles.error}>
                {this.getErrorMessage(error)}
              </div>
            : null}

            <DeletionForm
              loggingIn={submitting}
              onSubmit={this.handleLogin}
              email={user.email}
              clearErrors={this.clearErrors}
            />
          </div>
        :
          <div className={styles.formContainer}>

            {error ?
              <div className={styles.error}>
                {this.getErrorMessage(error)}
              </div>
            : null}

            {subscriptionPlatform === 'ios' ?
              <MvpConfirmation deactivate={() => this.handleDeactivation()} />
            :
              <div className={styles.secondaryFormContainer}>
                <SecondaryVerification
                  loggingIn={submitting}
                  onSubmit={this.handleDeactivation}
                  email={user.email}
                />
              </div>
            }
          </div>
         }

        {/*
          DEBUG information, only shown in local/devint
          Useful because DEVINT endpoints are often troublesome
        */}
        {userError && dev ?
          <div className={styles.userError}>
            <div className={styles.userErrorDescription}>
              You were logged in successfully, however there was an error fetching your user data.
              Feel free to try again, or just proceed to <a href="/my_home">my home</a>.
            </div>
            <div className={styles.userErrorMessage}>
              {userError.toString()} <br />
              {userError.response.status === 502 && 'Bad Gateway, server may be down or restarting'}
              {userError.response.status === 503 && 'Service Unavailable, server may be down or restarting'}
              {userError.response.status === 504 && 'Gateway Timeout, server took too long'}
            </div>
            <div><b>Host: </b>{userError.url.host}</div>
            <div><b>Path: </b>{userError.url.pathname}</div>
          </div>
        : null}
      </div>
      )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(Deletion)
